import { useStores } from '@storage/hooks/use-stores.hook'
import { useAsyncFetch } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { WeightClassSetContainerUIStore } from '../stores/weight-class-set-ui-store'
import { WeightClassSet } from './organisms/WeightClassSet'

const WeightClassesContainer = observer(({ formId }: { formId: string }) => {
  const {
    weightClassSetStore,
    vesselServiceStore,

    snackbarStore,
  } = useStores()

  const weightClassSetUIStore = useMemo(
    () =>
      new WeightClassSetContainerUIStore(snackbarStore, weightClassSetStore, vesselServiceStore),
    [snackbarStore, vesselServiceStore, weightClassSetStore],
  )

  useAsyncFetch(async () => {
    weightClassSetUIStore.refresh()
  }, [weightClassSetUIStore])

  const handleWeighClassSetOnSubmit = async () => {
    await weightClassSetUIStore.upsertWeightClassSets(weightClassSetUIStore.weightClassSetsControl)
  }

  return (
    <WeightClassSet
      id={formId}
      onSubmit={handleWeighClassSetOnSubmit}
      viewStore={weightClassSetUIStore}
    />
  )
})

export default WeightClassesContainer
